import React, { CSSProperties, FC, useEffect, useState } from "react"
import { AutoComplete, Flex, Typography } from "antd"
import { DefaultOptionType } from "antd/es/select"
import { CodeLibelle } from "../../../client/backend-client/generated"
import { ReferenceCode, useGetReferenceTyped } from "../../../queries/ReferenceQueries"
import { InputStatus } from "antd/es/_util/statusUtils"

const { Text } = Typography

interface CodeAPEOption extends DefaultOptionType {
  label: React.ReactNode
  value?: string | number | null
  codeLibelle?: CodeLibelle
  children?: Omit<DefaultOptionType, "children">[]
}

export const CodeAPEAutoComplete: FC<{
  codeLibelle?: CodeLibelle
  onChange: (value: CodeLibelle | undefined) => void
  allowClear?: boolean
  disabled?: boolean
  style?: CSSProperties
  status: InputStatus,  
  version:2008|2025
}> = ({ codeLibelle, onChange, allowClear, disabled, style, status, version }) => {
  const [searchText, setSearchText] = useState<string>()
  const [options, setOptions] = useState<CodeAPEOption[]>([])

  const { isLoading: areReferencesLoading, data: references } = useGetReferenceTyped<CodeLibelle>(
    version === 2008 ? ReferenceCode.CODE_APE : ReferenceCode.CODE_APE_2025
  )

  useEffect(() => {
    if (!areReferencesLoading && references) {
      setOptions(
        searchText
          ? references
              .filter(
                ref =>
                  ref.libelle.toLowerCase().includes(searchText.toLowerCase()) ||
                  ref.code.includes(searchText)
              )
              .map(renderCodeAPEOption)
          : references.map(renderCodeAPEOption)
      )
    }
  }, [references, searchText])

  const renderCodeAPEOption = (codeLibelle: CodeLibelle): CodeAPEOption => ({
    value: `${codeLibelle.code} - ${codeLibelle.libelle}`,
    codeLibelle: codeLibelle,
    label: (
      <>
        <Flex align="center" justify="start">
          <Text>
            <Text strong>{codeLibelle.code}</Text> - {codeLibelle.libelle}
          </Text>
        </Flex>
      </>
    )
  })

  return (
    <AutoComplete
      defaultValue={codeLibelle ? `${codeLibelle.code} - ${codeLibelle.libelle}` : undefined}
      searchValue={searchText}
      options={options}
      onSearch={value => setSearchText(value && value.trim() != "" ? value : undefined)}
      onSelect={(_, option: CodeAPEOption) => {
        onChange(option.codeLibelle)
      }}
      style={style ?? { width: "100%" }}
      allowClear={allowClear}
      onClear={() => onChange(undefined)}
      disabled={disabled}
      status={status}
    />
  )
}
